<div mat-dialog-content>
  <mat-grid-list cols="1" fxLayout="row" fxLayoutAlign="center center">
    <span mat-dialog-title><small>Cadastro de Usuário</small></span>
  </mat-grid-list>
</div>

<mat-vertical-stepper [linear]="false" #stepper class="call-operator">
  <form [formGroup]="formAddUser">
    <mat-step [stepControl]="firstFormGroup">
      <ng-template matStepLabel>Empresa:
        <span *ngIf="business != null">
          <b>{{ business.name }}</b>
        </span>
      </ng-template>
      <p><small><b>Selecione a Empresa:</b></small></p>

      <app-business-selection (businessSelected)="businessSelected($event)"></app-business-selection>
    </mat-step>

    <mat-step [stepControl]="secondFormGroup">
      <ng-template matStepLabel>Dados de Login</ng-template>
      <p><small><b>Defina os dados de acesso ao MHelp:</b></small></p>

      <!-- <app-login-data></app-login-data> -->
    <form
      autocomplete="off"
      fxLayout="column"
      fxLayout.lt-sm="column"
      fxLayoutAlign="start start"
      fxLayoutGap="10px"
      [formGroup]="formAddUser"
    >
      <mat-form-field appearance="outline" fxFlex="40" color="primary" >
        <mat-label>Nome de usuário:</mat-label>
        <input
          matInput
          placeholder="Nome Usuário"
          autocomplete="off"
          formControlName="name"
        >
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="50" color="primary" >
        <mat-label>Email:</mat-label>
        <input
          matInput
          formControlName="search"
          placeholder="Email de Contato"
          autocomplete="off"
          formControlName="email"
        >
      </mat-form-field>

      <mat-form-field appearance="outline"fxFlex="50" color="primary" >
        <mat-label>Celular:</mat-label>
        <input
          matInput
          mask="(00)00000-0000"
          placeholder="Numero de Celular"
          autocomplete="off"
          formControlName="mobile"
        >
      </mat-form-field>

      <div>
        <button mat-stroked-button color="primary" class="margin-form" matStepperPrevious>Voltar</button>
        <button mat-stroked-button color="primary" class="margin-form" matStepperNext>Próximo</button>
      </div>
    </form>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Confirmação</ng-template>
      <p>Para alterar alguma informação clique em Voltar.</p>
      <div>
        <button mat-stroked-button color="primary" class="margin-form" matStepperPrevious>Voltar</button>
        <button mat-stroked-button color="accent" class="margin-form" (click)="onSubmit()">Salvar</button>
        <button mat-stroked-button color="primary" class="margin-form" (click)="stepper.reset()">Novo</button>
      </div>
    </mat-step>
  </form>
</mat-vertical-stepper>
